interface StatusBadgeProps {
  active: boolean;
}

export const StatusBadge = ({ active }: StatusBadgeProps) => (
  <span
    className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${
      active
        ? "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-400"
        : "border border-red-200 text-red-600 dark:border-red-900/60 dark:text-red-400"
    }`}
  >
    {active ? "Ativo" : "Inativo"}
  </span>
);
